// Shared chart height for the 4 stacked historical behavior charts.
export const BEHAVIOR_GRAPH_HEIGHT = 200;

export const graphConfig = {
  axisLabel: { fontSize: 12 },
  colors: {
    actuals: '#274483',
    actualsLight: '#6E86C0',
    black: '#000000',
    forecast: '#14B8A6',
    gray: '#9ca3af',
    orange: '#ef6c00',
    p5: '#A2A2FF',
    p10: '#E0D4FF',
    p20: '#C2B2FF',
    p30: '#A58EFF',
    p40: '#8A72FF',
    p50: '#00613B',
    p60: '#6C5CFF',
    p70: '#5545FF',
    p75: '#4B3EFF',
    p80: '#4636FF',
    p85: '#3D30FF',
    p90: '#5856FF',
    p93: '#4F4DFF',
    p95: '#4745FF',
    p98: '#3F3DFF',
    smoothing: '#EF4444',
    teal: '#14B8A6',
  },
  grid: {
    // Small left/right inset so the dataZoom slider's end handles aren't clipped
    // at the chart edges (the slider spans the grid width).
    left: 8,
    right: 8,
    bottom: 40,
    top: 24,
    containLabel: true,
  },
} as const;
